import { Deserializable } from '../protocols/deserializable';
import { FundType } from '../transactions/fund-type';

export class WithdrawalInstruction implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  public percentage!: number;
  public fundBalance!: number | null;

  public onDeserialize() {
    if (this.fund) {
      this.fund = window.injector.Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
